@if (hasMyMailbox && unread > 0) {
  <div class="unread-badge" data-cy="loggedin-badge">
    <span class="m-auto">{{ unread }}</span>
  </div>
}
